// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  OrientationVersion,
  AssignmentStatus,
} from "./types";


export default __t.row({
  assignmentId: __t.u64().primaryKey().name("assignment_id"),
  email: __t.string(),
  userId: __t.option(__t.string()).name("user_id"),
  orientationId: __t.string().name("orientation_id"),
  projectId: __t.string().name("project_id"),
  get orientationVersion() {
    return OrientationVersion.name("orientation_version");
  },
  get status() {
    return AssignmentStatus;
  },
  assignedAt: __t.timestamp().name("assigned_at"),
  startedAt: __t.option(__t.timestamp()).name("started_at"),
  completedAt: __t.option(__t.timestamp()).name("completed_at"),
  cancelledAt: __t.option(__t.timestamp()).name("cancelled_at"),
  cohortAssignmentId: __t.option(__t.u64()).name("cohort_assignment_id"),
  cohortAdopted: __t.bool().name("cohort_adopted"),
});
